<template>
  <div class="post">
    <h2 class="title c5a ab">{{ title }}</h2>
    <div class="post_list">
      <Post v-for="(val, i) in post_list.articleThumbnailList"
      :title="val.title"
      :hashtag="val.tagList"
      :date="val.publicationDate"
      :is_new="val.is_new"
      :is_ranking="val.is_ranking"
      :id="val.id"
      :key="i"
      />
    </div>
    <MoreButton v-if="show_more" />
  </div>
</template>

<script>
import Post from '@/components/fanClub/column/Post';
import MoreButton from '@/components/fanClub/column/MoreButton';

export default {
  props: ['title', 'post_list', 'show_more'],
  components: {
    Post,
    MoreButton
  }
}
</script>

<style lang="css" scoped>
.title {
  text-align: center;
}
.post_list {
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/fanClub/column/PostList.vue